(function ($) {
	$(document).ready(function () {

		// For each instance of the Social Slider.
		$.each($('.rit-tour-archive-block'), function () {

			let this_block = $(this);

			$(".js-tour-archive-maps-toggle", this).on("click", function () {

				this_block.toggleClass("show-map-images");

			});

		});

	});
})(jQuery);
